/* dialog.tsx */
import { Fragment, useContext, useEffect } from 'react';
import { FeedbackComponent } from '../../chat/feedBack/feedBack';

import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm'

import { formatHtml } from '../../../core/formatHtml';
import { ChatUserContext } from '../../../core/chatContext';

import styles from './index.module.scss';
import { IconTel } from '../../../assets/svg/iconTel';

const AskComponent = (props: { userAsks: any }) => {
    const { userAsks } = props;


    return (
        <div className={styles.dialogContainerAskComponent}>
            <div className={styles.dialogContainerAskComponentText}>
                <ReactMarkdown className={styles.markdownTable} remarkPlugins={[remarkGfm]}>{typeof userAsks === 'string' ? formatHtml(userAsks) : null}</ReactMarkdown>
            </div>

            <div className={styles.dialogContainerChatAvatar}>
                Yo
            </div>
        </div>
    )
}

const AnswerComponent = (props: { iaAnswers: DialogComponents }) => {

    const { iaAnswers } = props;

    if (!iaAnswers) return (<></>);
    return (
        <div className={styles.dialogContainerAnswerComponent}>
            <div>
                <IconTel></IconTel>
            </div>
            <div className={styles.dialogContainerAnswerComponentText}>
                {iaAnswers?.id === "0" ? <p className={styles.loader}></p> : <></>}
                <ReactMarkdown className={styles.markdownTable} remarkPlugins={[remarkGfm]}>
                    {typeof iaAnswers.content === 'string' ? formatHtml(iaAnswers.content) : null}
                </ReactMarkdown>
            </div>

        </div>
    )
}

const DialogComponent: React.FC<{ userId: string, userPhoto: string, userAsks: string[], iaAnswers: DialogComponents[], enabledFeedBack: boolean }> = ({ userId, userPhoto, userAsks, iaAnswers, enabledFeedBack }) => {

    const currChatContext: any = useContext(ChatUserContext);

    const lines = userAsks.length;

    useEffect(() => {
        // Move scroll to bottom when update userAsks to see last response of IA
        const elemento = document.getElementById('bottomDialogContainer');
        elemento?.scrollIntoView({ behavior: 'smooth' });

    }, [userAsks, iaAnswers, currChatContext.currChat]);

    return (
        <div className={styles.dialogComponent}>
            <div className={styles.dialogContainer}>
                {!currChatContext.currChat.messages || currChatContext.currChat.messages.length === 0 ?
                    <div className={styles.dialogContainerAnswerComponent}>
                        <div>
                            <IconTel></IconTel>
                        </div>
                        <div className={styles.dialogContainerAnswerComponentText}>
                            Hola! Soy ShopIA tu asistente de compras , ¿ en que te puedo ayudar?
                        </div>
                    </div>
                    : null
                }
                {[...Array(lines)].map((elementInArray, index) => (
                    <Fragment key={index}>
                        <AskComponent key={`ask-${index}`} userAsks={userAsks[index]}></AskComponent>
                        <AnswerComponent key={`answer-${index}`} iaAnswers={iaAnswers[index]}></AnswerComponent>
                        {
                            enabledFeedBack &&
                            <FeedbackComponent
                                userId={userId}
                                conversationId={currChatContext.currChat.data_sources[0].parameters.conversationId}
                                idx={iaAnswers[index]}
                            />
                        }
                    </Fragment>
                )
                )}
                <div id="bottomDialogContainer"></div>
            </div>
        </div>
    )
}

export { DialogComponent }